import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Chip, { ChipTypes } from '@lib/components/Chip/Chip';
import ValidityHint from '@lib/enums/validityHint';
import styles from './validityHint.module.scss';

export function getValidityHintIcon(value?: string | null, size?: string) {
  if (!value) return null;
  if (value === ValidityHint.Failure) {
    return (
      <MaterialIcon
        icon="error"
        className={styles.validityHintOptionIconError}
        block
        size={size}
      />
    );
  }
  if (value === ValidityHint.Warning) {
    return (
      <MaterialIcon
        icon="warning"
        className={styles.validityHintOptionIconWarning}
        block
        size={size}
      />
    );
  }
  return (
    <MaterialIcon
      icon="check_circle"
      className={styles.validityHintOptionIconCheck}
      block
      size={size}
    />
  );
}

export function getValidityHintChipIcon(value?: string | null) {
  if (!value) return null;
  if (value === ValidityHint.Failure) {
    return <Chip leftIcon="error" type={ChipTypes.chipRed} />;
  }
  if (value === ValidityHint.Warning) {
    return <Chip leftIcon="warning" type={ChipTypes.chipOrange} />;
  }
  return <Chip leftIcon="check_circle" type={ChipTypes.chipGreen} />;
}
